export function getEntityTabSubTabDefaultItemLabel({ count, text }) {
  return count != null ? `${text} (${count})` : text
}

export function getEntityTabSubTabDefaultItemQaName({ qaName }) {
  return qaName
}
